import { render, staticRenderFns } from "./FaqWebForm.vue?vue&type=template&id=4c1c2ff2"
import script from "./FaqWebForm.vue?vue&type=script&lang=js"
export * from "./FaqWebForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports